export default "__VITE_ASSET__BXruy6Es__"